<template>
    <ul class="search-result-pagination">
        <li :class="{ disabled: Number(paginationPage) === 1 }" @click="decrement" >
            <i class="lnr lnr-chevron-left"></i>
        </li>
        <li style="width: 100px; position: relative;">
            <input
                v-model.number="paginationPage"
                @keydown.enter="submit"
                id="pagination-page"
                type="number"
                autocomplete="off"
            />
            <div id="pagination-count">
                из {{maxPages}}
            </div>
        </li>
        <li :class="{ disabled: Number(paginationPage) === Number(maxPages) }" @click="increment">
            <i class="lnr lnr-chevron-right"></i>
        </li>
    </ul>
</template>

<script>
export default {
    computed:{
        paginationPage: {
            get(){ return this.$store.state.search.pagination.page },
            set(value) { this.$store.commit('search/updatePage', value) }
        },
        pagination(){
            return this.$store.state.search.pagination
        },
        maxPages(){
            return this.$store.getters['search/maxPages']
        }
    },
    methods: {
        submit(e){
            this.$store.dispatch('search/getCards', {dont_save: true})
            e.target.blur()
        },
        increment(){
            if(this.$store.state.search.pagination.page >= 1 && this.$store.state.search.pagination.page < this.maxPages){
                this.$store.commit('search/updatePage', Number(this.$store.state.search.pagination.page) + 1)
                this.$store.dispatch('search/getCards', {dont_save: true})
            }
        },
        decrement(){
            if(this.$store.state.search.pagination.page > 1 && this.$store.state.search.pagination.page <= this.maxPages){
                this.$store.commit('search/updatePage', Number(this.$store.state.search.pagination.page) - 1)
                this.$store.dispatch('search/getCards', {dont_save: true})
            }
        }
    },
    watch: {
        paginationPage() {
            if(this.paginationPage > this.maxPages) {
                this.paginationPage = this.maxPages
            }

            if(this.paginationPage > 1000){
               this.paginationPage = 1000
            } else if(this.paginationPage < 1) {
               this.paginationPage = 1
            }
        }
    }
}
</script>

<style scoped>
    input {
        display: inline-block;
        font-family: Arial, sans-serif;
        font-weight: 300;
        width: 80px;
        border: solid 1px #999;
        border-radius: 4px;
        padding: 0 5px;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number] {
        -moz-appearance: textfield;
    }
    #pagination-count {
        position: absolute;
        height: 20px;
        bottom: -10px;
        padding: 0 3px;
        background: #fff;
        font-size: 10px;
        line-height: 20px;
        text-align: center;
        left: 50%;
        cursor: default;
    }
    .disabled i, .disabled {
        color: #444;
        opacity: 0.7;
    }
    .disabled i:hover, .disabled:hover {
        color: #444;
        opacity: 0.7;
        cursor: default;
    }
</style>
